var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-6 flex cursor-pointer shadow rounded-lg"},[_vm._t("default"),_c('div',{staticClass:"ml-auto my-auto"},[_c('n-icon',{attrs:{"name":_vm.collapsed ? 'Chevron-up' : 'Chevron-down'}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }